import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class EventVariantModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][Event Variant][getAll] organizationId & eventId are mandatory`);
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/products?expand=variants`;
    }
}
